/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.concat.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import Previewer from "vux/src/components/previewer/index.vue"; // this line is trasformed by vux-loader
import TransferDom from "vux/src/directives/transfer-dom/index.js"; // this line is trasformed by vux-loader
import ExtField from '@/components/ExtField';
export default {
  components: {
    ViewBox: ViewBox,
    Previewer: Previewer,
    ExtField: ExtField
  },
  directives: {
    // 指令
    TransferDom: TransferDom
  },
  props: {
    orderInfo: {
      type: Object,
      required: true
    },
    orderExtFields: {
      type: Array,
      required: true
    },
    remarkPicList: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    template: {
      type: Object,
      default: function _default() {}
    },
    extServiceItems: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          // eslint-disable-next-line
          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];
          if (thumbnail) {
            // eslint-disable-next-line
            var _thumbnail = document.querySelectorAll('.previewer-demo-img')[index];
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            if (_thumbnail.getBoundingClientRect) {
              var rect = _thumbnail.getBoundingClientRect();
              return {
                x: rect.left,
                y: rect.top + pageYScroll,
                w: rect.width
              };
            }
          }
        }
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('globalStore', ['user'])), {}, {
    remarkPicListForPreviewer: function remarkPicListForPreviewer() {
      return this.remarkPicList.map(function (item) {
        return {
          src: item.img_url
        };
      });
    },
    otherService: function otherService() {
      return this.extServiceItems.map(function (item) {
        return "".concat(item.service_name, " - ").concat(item.service_num, " ").concat(item.unit || i18n.tc("479"));
      }).join('\n');
    }
  }),
  methods: {
    goPersonInfo: function goPersonInfo() {
      this.$router.push({
        name: 'PersonInfo',
        params: {
          userId: this.orderInfo.fk_t_take_order_user_id
        }
      });
    },
    tel: function tel(phone) {
      this.$DingTalk && this.$DingTalk.biz.telephone.showCallMenu({
        phoneNumber: phone,
        // 期望拨打的电话号码
        code: '+86',
        // 国家代号，中国是+86
        showDingCall: true,
        // 是否显示钉钉电话
        onSuccess: function onSuccess() {},
        onFail: function onFail() {}
      });
    },
    show: function show(index) {
      var _this = this;
      this.$nextTick(function () {
        _this.$refs['previewer'].show(index);
      });
    }
  }
};